export function Loading () {
    return (
        <div className="loading-container">
            <img src="/favicon-laliga.png" alt="Logo Liga" />
        </div>
    )
}